import { toast } from 'react-toastify';
import {
    dropdownDeleteFun,
    dropdownEditFun,
    dropdownUploadFun,
    filterDeleteFun,
    filterEditFun,
    filterUploadFun
} from '../../../api/addDataAPI';
import errorHandle from '../../../utils/errorHandle';
import { supDropdownCount, supFilterCount, supportDropdown, supportFilter } from '../../../api/supportAdmin';

//Add dropdown
export const addDropdownSubmit = async (dropdownData, setLoading, type) => {
    try {
        let res;
        if (type === 'dropdown') res = await dropdownUploadFun(dropdownData);
        else res = await filterUploadFun(dropdownData);
        if (res.status === 200) {
            toast.success(`${type === 'dropdown' ? 'Dropdown' : 'Filter'} created successfully`);
            return res.status;
        }
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

//List dropdown
export const fetchDropdowns = (setDropDownData, setLoading, offset, limit, type, filter, status) => {
    setLoading(true);
    try {
        const url =
            filter === 'dropdown'
                ? supportDropdown(limit, offset, type, status)
                : supportFilter(10, offset, type, status);
        url.then((res) => {
            setDropDownData(res.data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

//Update dropdown
export const editDropdownSubmit = async (id, dropdownData, setLoading, type) => {
    try {
        let res;
        if (type === 'dropdown') res = await dropdownEditFun(id, dropdownData);
        else res = await filterEditFun(id, dropdownData);
        if (res.status === 200) {
            toast.success(`${type === 'dropdown' ? 'Dropdown' : 'Filter'} updated successfully`);
            return res.status;
        }
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

//Delete dropdown
export const deleteDropdown = async (id, setLoading, setDeleteModal, refresh, type) => {
    try {
        if (type === 'dropdown') await dropdownDeleteFun(id);
        else await filterDeleteFun(id);
        toast.success(`${type === 'dropdown' ? 'Dropdown' : 'Filter'} deleted successfully`);
        setLoading(false);
        setDeleteModal(false);
        refresh();
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const dropdownCount = (setTotalCount, type, setLoading) => {
    setLoading(true);
    try {
        supDropdownCount(type).then((res) => {
            setLoading(false);
            setTotalCount(res.data.count);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const filterCount = (setTotalCount, setLoading) => {
    setLoading(true);
    try {
        supFilterCount().then((res) => {
            setLoading(false);
            setTotalCount(res.data.count);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
